import React, { Fragment } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { Icon, Text } from '@ui-kitten/components';

import lodashIsEmpty from 'lodash/isEmpty';

import Button from '../../Button';

import AnalyticsHelper from '../../../Helper/Analytics';
import ImageHelper from '../../../Helper/Image';

import ThemeColor from '../../../Theme/colors';
import ThemeStyle from '../../../Theme/styles';

import Image from '../../Image';
import useFavorites from '../../../Hooks/useFavorite';
import HorizontalListing, { getMarginStyle } from '../../HorizontalListing';
import ItemSmall from '../../Card/ItemSmall';
import { capitalize, formatDistance, formatDuration } from '../../../Helper';
import Badge from '../../Badge';
import RatingText from '../../RatingText';
import { subTitleProps } from '../../Card/styles';
import routeList from '../../../Routes/list';

const SearchedItemWeb = (props) => {
  const { item, searchValue, showItemModal } = props;
  const navigation = useNavigation();
  const { isLoading, isSaved, toggleFavourite } = useFavorites(item.id);

  const storeImage = ImageHelper.getOrderImage(item);

  const _goToStore = () => {
    // @ts-ignore
    navigation.navigate(routeList.STORE, {
      id: item?.id,
      distance: item?.distance,
      duration: item?.duration,
    });
  };

  const _onStoreItemResultPressed = (storeItem) => {
    AnalyticsHelper.itemSelection({
      ...storeItem,
      fromSection: `Search result from '${searchValue}'`,
    });
    showItemModal({
      storeName: item.name,
      storeImage,
      item_id: storeItem?.id,
      ...storeItem,
    });
  };

  return (
    <Fragment>
      <Button style={styles.storeItemSearch} onPress={_goToStore} plain>
        <View style={styles.searched_item_result_container}>
          {/* @ts-ignore: component is js file */}
          <Image
            source={{ uri: storeImage }}
            style={styles.image_search_result}
            resizeMode="cover"
            accessibilityRole="link"
            href={`/${routeList.STORE}?id=${item?.id}&distance=${item?.distance}6&duration=${item?.duration}`}
            target="_blank"
          />
        </View>
        <View style={styles.description_search_result}>
          {/* Store name & distance */}
          <View
            accessibilityRole="link"
            // @ts-ignore: href works on web, not recognize on react native
            href={`/${routeList.STORE}?id=${item?.id}&distance=${item?.distance}6&duration=${item?.duration}`}
            target="_blank"
          >
            <Text category="p1" numberOfLines={1}>
              {item.name}
            </Text>

            <View style={ThemeStyle.flexDirectionRowCenter}>
              {Boolean(item?.duration) && (
                <Icon
                  name="motorcycle"
                  pack="fa"
                  fill={ThemeColor.green}
                  style={[styles.durationIcon, ThemeStyle.spacingRightSmall]}
                />
              )}
              <Text {...subTitleProps}>
                {Boolean(item?.duration) &&
                  `${formatDuration(item?.duration)} min · `}
                {formatDistance(item?.distance)}
              </Text>
            </View>
          </View>

          {/* Icon & Delivery duration, save button and store rating */}
          <View style={ThemeStyle.alignItemsEnd}>
            <Button
              disabled={isLoading}
              hitSlop={{ top: 10, left: 10, bottom: 10 }}
              onPress={toggleFavourite}
              plain
            >
              <Icon
                name={isSaved ? 'heart' : 'heart-outline'}
                fill={isSaved ? ThemeColor.green : ThemeColor.gray}
                style={styles.storeIcon}
              />
            </Button>

            <RatingText type={1} storeId={item?.id} {...subTitleProps} />

            {/* Store tags */}
            {!lodashIsEmpty(item?.store_tags) && (
              <View
                style={[
                  ThemeStyle.flexDirectionRowCenter,
                  ThemeStyle.spacingTopSmall,
                ]}
              >
                {item?.store_tags.slice(0, 3).map((tag, i) => (
                  <View
                    key={i}
                    style={[{ flexShrink: 1 }, ThemeStyle.spacingLeftSmall]}
                  >
                    <Badge
                      style={{
                        borderRadius: 20,
                        paddingHorizontal: 8,
                      }}
                      category={Badge.CATEGORIES.BASIC}
                      type={Badge.TYPES.SOLID}
                      numberOfLines={1}
                      adjustsFontSizeToFit
                      size={'c1'}
                    >
                      {capitalize(tag)}
                    </Badge>
                  </View>
                ))}
              </View>
            )}
          </View>
        </View>
      </Button>

      {!lodashIsEmpty(item?.searched_items) && (
        <View
          style={[
            ThemeStyle.spacingBottomMedium,
            ThemeStyle.pageHorizontalSpacing,
          ]}
        >
          {/* @ts-ignore: component is js file */}
          <HorizontalListing
            data={item?.searched_items}
            renderItem={({ isFirstOfList, isLastOfList, item }) => (
              <View style={getMarginStyle(isFirstOfList, isLastOfList, false)}>
                <ItemSmall
                  {...item}
                  onPress={() => _onStoreItemResultPressed(item)}
                />
              </View>
            )}
            style={{ marginHorizontal: 0, ...ThemeStyle.pageBackground }}
            arrowStyles={{ transform: [{ translateY: 0 }] }}
            arrowContentStyles={{ width: 30, height: 30 }}
            arrowIcon={{ width: 20, height: 20 }}
          />
        </View>
      )}
    </Fragment>
  );
};

const styles = StyleSheet.create({
  storeItemSearch: {
    ...ThemeStyle.flex1,
    height: 60,
    paddingHorizontal: 10,
    paddingVertical: 15,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginHorizontal: 15,
  },
  searched_item_result_container: {
    width: 60,
    height: 60,
    borderRadius: 30,
    borderWidth: 1,
    borderColor: ThemeColor.gray,
    aspectRatio: 0.1,
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image_search_result: {
    width: 60,
    height: 60,
    borderRadius: 30,
  },
  description_search_result: {
    marginLeft: 10,
    justifyContent: 'space-between',
    flexDirection: 'row',
    flex: 1,
  },
  storeIcon: {
    width: 20,
    height: 20,
  },
  durationIcon: {
    width: 14,
    height: 14,
  },
});

export default SearchedItemWeb;
